import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import 'react';
import PropTypes from 'prop-types';
import { Col } from '@hausgold/designsystem';
import { jsx } from '@emotion/react';
var _excluded = ["children", "position"];
var ChoiceOptionColContainer = function ChoiceOptionColContainer(_ref) {
  var children = _ref.children,
    position = _ref.position,
    props = _objectWithoutProperties(_ref, _excluded);
  var colWidth = {
    base: 1 / 2,
    sm: 1 / 4
  };

  /**
   * Special breakpoints for variants
   */
  if (position === 'right' || position === 'top') {
    colWidth = {
      base: 1 / 2,
      sm: 1 / 4,
      md: 1 / 2
    };
  }
  return jsx(Col, _extends({
    mb: 4,
    pl: 4,
    width: colWidth
  }, props), children);
};
ChoiceOptionColContainer.propTypes = {
  children: PropTypes.node,
  position: PropTypes.oneOf(['right', 'top', 'header'])
};
ChoiceOptionColContainer.defaultProps = {
  children: null,
  position: 'header'
};
export { ChoiceOptionColContainer as default };